import { z } from 'zod';
import { PaginationQuerySchema } from './common.js';
import { ConceptSelectionSchema } from './prompt-blocks.js';
import { SSEStatusEventSchema, SSEImageEventSchema, SSEErrorEventSchema } from './ai.js';
import { PaymentTypeSchema } from './payment.js';
// ============================================================
// Admin User Action Schemas
// ============================================================
export const GrantCreditsActionSchema = z.object({
    action: z.literal('grant_credits'),
    userId: z.string().cuid2(),
    credits: z.number().int().min(1).max(100),
});
export const SetPremiumActionSchema = z.object({
    action: z.literal('set_premium'),
    userId: z.string().cuid2(),
});
export const SetFreeActionSchema = z.object({
    action: z.literal('set_free'),
    userId: z.string().cuid2(),
});
export const SetAdminActionSchema = z.object({
    action: z.literal('set_admin'),
    userId: z.string().cuid2(),
});
export const SetUserActionSchema = z.object({
    action: z.literal('set_user'),
    userId: z.string().cuid2(),
});
export const ActivateUserActionSchema = z.object({
    action: z.literal('activate'),
    userId: z.string().cuid2(),
});
export const DeactivateUserActionSchema = z.object({
    action: z.literal('deactivate'),
    userId: z.string().cuid2(),
});
export const AdminUserActionSchema = z.discriminatedUnion('action', [
    GrantCreditsActionSchema,
    SetPremiumActionSchema,
    SetFreeActionSchema,
    SetAdminActionSchema,
    SetUserActionSchema,
    ActivateUserActionSchema,
    DeactivateUserActionSchema,
]);
// ============================================================
// Query Schemas
// ============================================================
export const AdminUsersQuerySchema = PaginationQuerySchema.extend({
    search: z.string().optional(),
    plan: z.enum(['FREE', 'PREMIUM']).optional(),
    sortBy: z.enum(['createdAt', 'email', 'name', 'aiCredits']).default('createdAt'),
});
export const AdminPaymentsQuerySchema = PaginationQuerySchema.extend({
    status: z.enum(['PENDING', 'COMPLETED', 'FAILED', 'REFUNDED']).optional(),
    type: PaymentTypeSchema.optional(),
    userId: z.string().cuid2().optional(),
    startDate: z.string().datetime().optional(),
    endDate: z.string().datetime().optional(),
    sortBy: z.enum(['createdAt', 'amount']).default('createdAt'),
});
export const AdminGenerationsQuerySchema = PaginationQuerySchema.extend({
    status: z.enum(['PENDING', 'PROCESSING', 'COMPLETED', 'FAILED']).optional(),
    style: z.string().optional(),
    modelId: z.string().optional(),
    userId: z.string().optional(),
    search: z.string().optional(),
    startDate: z.string().optional(),
    endDate: z.string().optional(),
    isAdminTest: z.enum(['true', 'false']).optional(),
    sortBy: z.enum(['createdAt', 'cost', 'creditsUsed']).default('createdAt'),
});
// ============================================================
// Admin AI Test Generate
// ============================================================
export const AdminTestGenerateSchema = z.object({
    imageUrls: z.array(z.string()).min(1).max(5),
    modelId: z.string().optional(),
    style: z.string().optional(),
    role: z.enum(['GROOM', 'BRIDE', 'COUPLE']).default('GROOM'),
    customPrompt: z.string().optional(),
    count: z.number().int().min(1).max(10).default(1),
    promptBlocks: ConceptSelectionSchema.optional(),
});
export const AdminTestGenDoneEventSchema = z.object({
    type: z.literal('done'),
    generationId: z.string(),
    urls: z.array(z.string()),
    cost: z.number(),
    modelId: z.string(),
    prompt: z.string(),
});
export const AdminSSEEventSchema = z.discriminatedUnion('type', [
    SSEStatusEventSchema,
    SSEImageEventSchema,
    AdminTestGenDoneEventSchema,
    SSEErrorEventSchema,
]);
//# sourceMappingURL=admin.js.map